import { render, staticRenderFns } from "./ServiceEntitlements.vue?vue&type=template&id=89351470&"
import script from "./ServiceEntitlements.vue?vue&type=script&lang=js&"
export * from "./ServiceEntitlements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports